import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { BenefitCashbackContainer } from '@shared/benefits/containers/benefit-cashback/benefit-cashback.container';
import { BenefitInstallmentsContainer } from '@shared/benefits/containers/benefit-installments/benefits-installments.container';
import { FinancialPartnersComponent } from '@shared/benefits/components/financial-partners/financial-partners.component';
import { BankPartnersComponent } from '@shared/benefits/components/bank-partners/bank-partners.component';
import { CardPartnersComponent } from '@shared/benefits/components/card-partners/card-partners.component';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { ModalModule } from '@ux/components/modal/modal.module';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { DividerDsComponent } from '@design-system/components/atoms/divider/divider.component';

@NgModule({
  declarations: [
    BenefitCashbackContainer,
    BenefitInstallmentsContainer,
    FinancialPartnersComponent,
    BankPartnersComponent,
    CardPartnersComponent,
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    SwipeUpModule,
    ModalModule,
    IconDsComponent,
    DividerDsComponent,
  ],
  exports: [
    BenefitCashbackContainer,
    BenefitInstallmentsContainer,
    FinancialPartnersComponent
  ]
})
export class BenefitsModule { }
